import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginationScrollDirective } from './directives/pagination-scroll.directive';
import { StickyDirective } from './directives/sticky.directive';
import { StopPropagationDirective } from './directives/stop-propagation.directive';
import { FilterPipe } from './pipes/filter.pipe';
import { LocalizationPipe } from './pipes/localization.pipe';
import { PhonePipe } from './pipes/phone.pipe';
import { PluralizePipe } from './pipes/pluralize.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { DatePipe } from './pipes/date.pipe';
import { DialogPageComponent } from './components/dialog-page/dialog-page.component';
import { ProgressModule } from '../progress/progress.module';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ButtonModule } from '../button/button.module';
import { FireEventDirective } from './directives/fire-event.directive';
import { AgreementComponent } from './components/agreement/agreement.component';
import { FitToParentDirective } from './directives/fit-to-parent.directive';
import { ScrollShadowComponent } from './components/scroll-shadow/scroll-shadow.component';
import { DownloadDirective } from './directives/download.directive';
import {SuggestHighlightPipe} from './pipes/suggest-highlight.pipe';
import { LocalizationModule } from '../localization/localization.module';

@NgModule({
  imports: [
    CommonModule,
    ProgressModule,
    ButtonModule,
    LocalizationModule,
  ],
  declarations: [
    AgreementComponent,
    DialogPageComponent,
    ConfirmDialogComponent,
    ScrollShadowComponent,

    PaginationScrollDirective,
    StickyDirective,
    StopPropagationDirective,
    FireEventDirective,
    FitToParentDirective,
    DownloadDirective,

    FilterPipe,
    LocalizationPipe,
    PhonePipe,
    PluralizePipe,
    SafePipe,
    DatePipe,
    SuggestHighlightPipe,
  ],
  exports: [
    AgreementComponent,
    DialogPageComponent,
    ConfirmDialogComponent,
    ScrollShadowComponent,

    PaginationScrollDirective,
    StickyDirective,
    StopPropagationDirective,
    FireEventDirective,
    FitToParentDirective,
    DownloadDirective,

    FilterPipe,
    LocalizationPipe,
    PhonePipe,
    PluralizePipe,
    SafePipe,
    DatePipe,
    SuggestHighlightPipe,
  ]
})
export class UtilsModule {}
